import React from 'react';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';
import StandingOrderItem from './StandingOrderItem';
import useTranslate from 'lib/languages/useTranslate';

import { StandingOrder as StandingOrderData } from 'lib/type';

interface StandingOrderProps {
    data: StandingOrderData[];
}

const StandingOrder = ({ data }: StandingOrderProps) => {
    const translate = useTranslate('standingOrders');

    return (
        <div className="standing-order-container">
            <SectionTitle title={translate('active')} secondary />
            <div className="active-container">
                {data
                    .filter(({ isDeleted }) => !isDeleted)
                    .map(item => (
                        <StandingOrderItem key={item.id} item={item} />
                    ))}
            </div>
            <SectionTitle title={translate('cancelled')} secondary />
            <div className="cancelled-container">
                {data
                    .filter(({ isDeleted }) => isDeleted)
                    .map(item => (
                        <StandingOrderItem key={item.id} item={item} />
                    ))}
            </div>
        </div>
    );
};

export default StandingOrder;
